const imgURL = 'http://img.chuang.js.cn'

export default {
    imgURL
  }


// WEBPACK FOOTER //
// ./src/api/global.js